import * as tslib_1 from "tslib";
import { Tools } from "./tools";
/**
 * This can helps recording videos from BabylonJS.
 * This is based on the available WebRTC functionalities of the browser.
 *
 * @see http://doc.babylonjs.com/how_to/render_scene_on_a_video
 */
var VideoRecorder = /** @class */ (function () {
    /**
     * Create a new VideoCapture object which can help converting what you see in Babylon to
     * a video file.
     * @param engine Defines the BabylonJS Engine you wish to record
     * @param options Defines options that can be used to customized the capture
     */
    function VideoRecorder(engine, options) {
        if (options === void 0) { options = null; }
        if (!VideoRecorder.IsSupported(engine)) {
            throw "Your browser does not support recording so far.";
        }
        var canvas = engine.getRenderingCanvas();
        if (!canvas) {
            throw "The babylon engine must have a canvas to be recorded";
        }
        this._canvas = canvas;
        this._canvas.isRecording = false;
        this._options = tslib_1.__assign({}, VideoRecorder._defaultOptions, options);
        var stream = this._canvas.captureStream(this._options.fps);
        if (this._options.audioTracks) {
            for (var _i = 0, _a = this._options.audioTracks; _i < _a.length; _i++) {
                var track = _a[_i];
                stream.addTrack(track);
            }
        }
        this._mediaRecorder = new MediaRecorder(stream, { mimeType: this._options.mimeType });
        this._mediaRecorder.ondataavailable = this._handleDataAvailable.bind(this);
        this._mediaRecorder.onerror = this._handleError.bind(this);
        this._mediaRecorder.onstop = this._handleStop.bind(this);
    }
    /**
     * Returns wehther or not the VideoRecorder is available in your browser.
     * @param engine Defines the Babylon Engine to check the support for
     * @returns true if supported otherwise false
     */
    VideoRecorder.IsSupported = function (engine) {
        var canvas = engine.getRenderingCanvas();
        return (!!canvas && typeof canvas.captureStream === "function");
    };
    Object.defineProperty(VideoRecorder.prototype, "isRecording", {
        /**
         * True wether a recording is already in progress.
         */
        get: function () {
            return !!this._canvas && this._canvas.isRecording;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Stops the current recording before the default capture timeout passed in the startRecording
     * functions.
     */
    VideoRecorder.prototype.stopRecording = function () {
        if (!this._canvas || !this._mediaRecorder) {
            return;
        }
        if (!this.isRecording) {
            return;
        }
        this._canvas.isRecording = false;
        this._mediaRecorder.stop();
    };
    /**
     * Starts recording the canvas for a max duration specified in parameters.
     * @param fileName Defines the name of the file to be downloaded when the recording stop. If null no automatic download will start and you can rely on the promise to get the data back.
     * @param maxDuration Defines the maximum recording time in seconds.
     * It default to 7 seconds. A value of zero will not stop automatically, you would need to call stopRecording manually.
     * @return a promise callback at the end of the recording with the video data in Blob.
     */
    VideoRecorder.prototype.startRecording = function (fileName, maxDuration) {
        var _this = this;
        if (fileName === void 0) { fileName = "babylonjs.webm"; }
        if (maxDuration === void 0) { maxDuration = 7; }
        if (!this._canvas || !this._mediaRecorder) {
            throw "Recorder has already been disposed";
        }
        if (this.isRecording) {
            throw "Recording already in progress";
        }
        if (maxDuration > 0) {
            setTimeout(function () {
                _this.stopRecording();
            }, maxDuration * 1000);
        }
        this._fileName = fileName;
        this._recordedChunks = [];
        this._resolve = null;
        this._reject = null;
        this._canvas.isRecording = true;
        this._mediaRecorder.start(this._options.recordChunckSize);
        return new Promise(function (resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    };
    /**
     * Releases internal resources used during the recording.
     */
    VideoRecorder.prototype.dispose = function () {
        this._canvas = null;
        this._mediaRecorder = null;
        this._recordedChunks = [];
        this._fileName = null;
        this._resolve = null;
        this._reject = null;
    };
    VideoRecorder.prototype._handleDataAvailable = function (event) {
        if (event.data.size > 0) {
            this._recordedChunks.push(event.data);
        }
    };
    VideoRecorder.prototype._handleError = function (event) {
        this.stopRecording();
        if (this._reject) {
            this._reject(event.error);
        }
        else {
            throw new event.error();
        }
    };
    VideoRecorder.prototype._handleStop = function () {
        this.stopRecording();
        var superBuffer = new Blob(this._recordedChunks);
        if (this._resolve) {
            this._resolve(superBuffer);
        }
        window.URL.createObjectURL(superBuffer);
        if (this._fileName) {
            Tools.Download(superBuffer, this._fileName);
        }
    };
    VideoRecorder._defaultOptions = {
        mimeType: "video/webm",
        fps: 25,
        recordChunckSize: 3000
    };
    return VideoRecorder;
}());
export { VideoRecorder };
//# sourceMappingURL=videoRecorder.js.map